import { useRef, useState } from "react";

export const useResponsiveScrollModalSelectCandidates = () => {
  const [mainContainer, setMainContainer] = useState<HTMLDivElement | null>(null);
  const staticContainerRef = useRef<HTMLDivElement>(null);
  const scrollerRef = useRef<HTMLDivElement | null>(null);

  return { mainContainer, setMainContainer, staticContainerRef, scrollerRef };
};
